/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CampoMensa } from './campo-mensa';


export interface ServizioMensaAttributoMappingUpsertForm { 
    campo_mensa: CampoMensa;
    attributo_id: string;
    version?: number;
}



